import React from 'react';
import { LanguageProvider } from './hooks/useLanguage';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-[#fdfbf9] font-sans text-[#152c61]" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <ServicesSection data-id="element-5" />
          {/* Smooth transition from white to warm */}
          <div className="h-24 bg-gradient-to-b from-white to-[#faf8f5]" data-id="element-6" />
          <AboutSection data-id="element-7" />
          {/* Clean architectural transition — premium brands use confident cuts, not blended gradients */}
          <div className="relative" data-id="element-8">
            <div className="h-32 bg-[#faf8f5]" data-id="element-9" />
            <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#ae6470]/20 to-transparent" data-id="element-10" />
          </div>
          <ContactSection data-id="element-11" />
          <Footer data-id="element-12" />
        </main>
      </div>
    </LanguageProvider>;
}